export default "__VITE_ASSET__D0SRH$94__"